import React from "react";
import ReactHtmlParser from "react-html-parser";
import { Video, VideoChat, VideoMeta, Heartbeater } from "Components";
import { BodySection, Layout } from "../Layout";
import { AuthAccess } from "services";

export const Show = ({ event, token }) => {
  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  let headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  headerLogo = `/assets/${event?.logos?.header?.path}`;
  // const footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;

  return (
    <>
      <Layout
        // header
        headerShowLogo={true}
        headerLogo={headerLogo}
        headerSecondaryText={event.header}
        // hero
        heroContent={
          event?.show?.chatActive ? (
            <VideoChat
              videoId={event?.show?.videoId}
              chatId={event?.show?.chatId}
              videoMeta={<VideoMeta />}
            />
          ) : (
            <Video id={event?.show?.videoId} />
          )
        }
        heroPadding={event?.show?.chatActive ? 0 : "56.25%"}
        videoStyle={
          event?.show?.chatActive
            ? { position: "relative", width: "100%" }
            : undefined
        }
        // heading
        // heading={event?.show?.heading}
        // main
        subHeading={event?.show?.subHeading}
        noPadding
        // add-ons
        noAddons
        // footer
        footerShow={false}
        footerShowLogo
        footerLogo={headerLogo}
        footerShowText
        footerPrivacyPolicy={event?.footer}
      >
        {event?.show?.body ? (
          <BodySection>{ReactHtmlParser(event?.show?.body)}</BodySection>
        ) : undefined}
      </Layout>
      <AuthAccess token={token} />
      <Heartbeater />
    </>
  );
};
